<template>
  <div class="tabs polymerization">
    <div class="list-cont" v-loading="contLoading">
      <div class="rightSlide">
        <div class="search">
          <ElForm inline @submit.native.prevent class="elementui-common-form-styles" v-highlight>
            <ElFormItem>
              <ElInput v-model.trim="gameName" placeholder="请输入搜索应用名称" @keyup.enter.native="search">
                <i slot="append" @click="search" class="el-icon-search"></i>
              </ElInput>
            </ElFormItem>

            <ElFormItem class="bg-transparent">
              <el-button type="primary" @click="add" :disabled="!gameData.length">添加应用</el-button>
            </ElFormItem>
          </ElForm>
        </div>
        <el-table
          class="common-el-table-styles"
          :data="tableData"
          border
          v-loading="loading"
          height="calc(100vh - 260px)"
          style="width: 100%"
        >
          <el-table-column label="应用" width="200px">
            <template slot-scope="{ row }">
              <div class="appInfo">
                <img :src="row.openGameIconRootPath + row.iconPath" alt="" />
                <div class="info">
                  <el-tooltip class="item" effect="dark" :content="row.appName" placement="top-start">
                    <p class="title">
                      {{ row.appName }}
                    </p>
                  </el-tooltip>
                  <p>ID: {{ row.gameId }}</p>
                  <p>
                    <el-button
                      type="text"
                      class="copy"
                      v-clipboard:copy="
                        `##外部参数##\nappid:${row.gameId}\nappkey:${row.mAppKey}\nchannel_apply_id:${row.chGameId}\nchannel_id: ${row.channelId}\n` +
                        '\n' +
                        `##内部分包##\n投放渠道ID: ${row.ptomChannelId}\n投放子渠道ID: ${row.ptomSourceId}\n子应用ID: ${row.devGameId}\n子应用appKey: ${row.appKey}\n子应用serverKey: ${row.serverKey}`
                      "
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                      >复制参数</el-button
                    >
                  </p>
                </div>
                <span>
                  <i v-if="row.platform === 1"><Icon type="logo-android"></Icon></i>
                  <i v-else><Icon type="logo-apple"></Icon></i>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="accessType" label="应用模式" width="80px">
            <template slot-scope="{ row }">
              {{ row.accessType === 2 ? '移动追踪' : '聚合追踪' }}
            </template>
          </el-table-column>
          <el-table-column label="支持媒体">
            <template slot-scope="{ row }">
              <p v-for="(media, index) in row.mediaGameName" :key="index">{{ media.mediaName }}：{{ media.mediaGameName }}</p>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="{ row }">
              {{ row.addTime | datetimeToSec }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间">
            <template slot-scope="{ row }">
              {{ row.updateTime | datetimeToSec }}
            </template>
          </el-table-column>
          <el-table-column label="包体状态">
            <template slot-scope="{ row }">
              <div class="uploadState" v-if="row.uploadPackState === 1">
                <span>
                  <p>{{ row.updatePackTime | datetimeToSec }}</p>
                  <p style="margin-top: 5px">{{ row.packageUpName }}</p>
                </span>
                <a :href="row.packageRootPath" download><i class="el-icon-download"></i></a>
              </div>
              <div v-if="row.uploadPackState === 0">未上传</div>
              <div v-if="row.uploadPackState === 2">上传中</div>
              <div v-if="row.uploadPackState === 3">上传失败</div>
            </template>
          </el-table-column>
          <el-table-column label="数据状态" width="120px">
            <template slot-scope="{ row }">
              {{ row.packageDebugState === 0 ? '未接入' : '正常' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300px">
            <template slot-scope="{ row }">
              <el-button type="text" @click="polyAccess(row)" v-if="row.packageDebugState === 0">接入</el-button>
              <el-button type="text" @click="pack(row)">打包</el-button>
              <el-button type="text" @click="packConfig(row)">包体配置</el-button>
              <el-button type="text" @click="mediaConfig(row)">媒体配置</el-button>
              <el-button type="text" @click="update(row)">传包</el-button>
              <el-button type="text" @click="dele(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Page
          v-if="tableData && tableData.length"
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page"
          size="small"
        />
      </div>
      <div class="leftSlide">
        <Form inline @submit.native.prevent>
          <ElInput
            v-model.trim="applicationName"
            placeholder="请输入搜索聚合应用名称"
            style="width: 200px; margin-top: 3px"
            @keyup.enter.native="search"
          >
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </Form>
        <ul class="list">
          <li v-for="(item, index) in gameData" :key="index" :class="active === index ? 'active' : ''" @click="getTableData(item, index)">
            <img :src="item.imgUrlRootPath + item.iocnPath" alt="" />
            <el-tooltip class="item" effect="dark" :content="item.gameName" placement="top-start">
              <p class="title">{{ item.gameName }}</p>
            </el-tooltip>
            <p class="id">ID: {{ item.gameId }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!--传包-->
    <uploadDialog
      :isShowDialog="isShowDialog"
      :uploadData="uploadData"
      v-on:closeUploadDialog="closeUploadDialog"
      :gameId="gameId"
      :pageType="'polymerization'"
    ></uploadDialog>
    <!--包体配置-->
    <el-drawer title="" :visible.sync="packDialogVisible" :direction="'rtl'" :show-close="false" size="45%" :before-close="handleClose">
      <div class="editDialog">
        <packConfig ref="packConfig" :packData="packData"></packConfig>
      </div>
      <span class="dialog-footer">
        <el-button @click="packDialogVisible = false" size="large">退 出</el-button>
        <el-button type="primary" @click="submit" size="large">确 定</el-button>
      </span>
    </el-drawer>
  </div>
</template>
<script>
import uploadDialog from './uploadDialog'
import packConfig from './packConfig'
import {
  queryALLGameByAuth,
  queryChannelAggregationAppByPage,
  deleteChannelAggregationApp,
  channelPackByConfigId,
  updataChannelConfig,
  updataIosChannelConfig
} from '@/api/sysmana.model'
export default {
  name: 'comperhensive',
  props: ['polymerizationData'],
  components: {
    uploadDialog,
    packConfig
  },
  data() {
    return {
      gameName: '',
      applicationName: '',
      gameData: [],
      options: [
        {
          value: 1,
          label: '聚合追踪'
        },
        {
          value: 2,
          label: '移动追踪'
        }
      ],
      tableData: [],
      loading: false,
      isShowDialog: false,
      packDialogVisible: false,
      packData: {},
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      gameId: 0,
      uploadData: {},
      active: 0,
      polyAccessItem: {}
    }
  },
  created() {
    this.applicationName = this.polymerizationData.gameName || ''
    this.getData()
  },
  destroyed() {
    this.$emit('destroyedFn', {})
  },
  methods: {
    getData() {
      this.contLoading = true
      this.gameData = []
      queryALLGameByAuth({
        gameName: this.applicationName
      }).then((data) => {
        if (data) {
          this.contLoading = false
          if (data.length) {
            data.forEach((item) => {
              this.gameData.push(item)
            })
          }
          this.getAppByPage(data && data.length && data[0].gameId)
          this.gameId = data && data.length && data[0].gameId
          this.polyAccessItem = data && data.length && data[0]
        }
      })
    },
    getAppByPage(gameId) {
      this.loading = true
      this.tableData = []
      queryChannelAggregationAppByPage({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        gameId: gameId,
        gameName: this.gameName
      }).then((data) => {
        if (data) {
          this.loading = false
          this.total = data.page_info && data.page_info.total_number
          if (typeof data.list !== 'undefined') {
            data.list.forEach((item) => {
              this.tableData.push(item)
            })
          }
        }
      })
    },
    getTableData(item, index) {
      this.getAppByPage(item.gameId)
      this.gameId = item.gameId
      this.active = index
      this.polyAccessItem = item
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getAppByPage(this.gameId)
    },
    changePageSize(size) {
      this.pageSize = size
      this.getAppByPage(this.gameId)
    },
    search() {
      this.pageIndex = 1
      this.getAppByPage(this.gameId)
    },
    searchApplication() {
      this.active = 0
      this.getData()
    },
    onCopy() {
      this.$Message.success('复制成功！')
    },
    onError() {
      this.$Message.warning('剪切板禁止访问')
    },
    add() {
      // 添加聚合应用
      window.open(
        '/addapplication/addlayout?name=polymerization&mgameId=' + this.gameId + '&addItem=' + JSON.stringify(this.polyAccessItem)
      )
    },
    polyAccess(item) {
      // 聚合接入
      window.open('/addapplication/addlayout?name=polymerization&row=' + JSON.stringify(item))
    },
    closeUploadDialog() {
      this.isShowDialog = false
    },
    pack(item) {
      // 打包
      channelPackByConfigId({
        id: item.id
      }).then((data) => {
        if (data) {
          this.getData()
        }
      })
    },
    mediaConfig(item) {
      // 媒体配置
      window.open('/tools/appmanage/add?devGameId=' + item.devGameId + '&t=edit')
    },
    packConfig(item) {
      // 包体配置
      this.packDialogVisible = true
      this.packData = item
    },
    update(item) {
      // 传包
      this.isShowDialog = true
      this.uploadData = item
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    dele(item) {
      this.$confirm('确认是否删除该应用？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        deleteChannelAggregationApp({
          id: item.id
        }).then((data) => {
          if (data) {
            this.$message.success('删除成功')
            this.getData()
          }
        })
      })
    },
    submit() {
      const refPackConfig = this.$refs.packConfig
      const clientConfigs = refPackConfig.submitClientConfigKeys()
      const configs = refPackConfig.submitServerConfigKeys()
      const goodconfigs = refPackConfig.submitGoodsConfig()
      const pluginConfigs = refPackConfig.submitPluginConfigs()
      const packInfoData = refPackConfig.submitPackInfo()
      const androidConfigVo = {
        configs,
        clientConfigs,
        goodconfigs,
        pluginConfigs,
        ...packInfoData
      }
      this.$refs.packConfig.$refs.packInfoConfigs.$refs.packInfoConfig.validate((valid) => {
        if (valid) {
          const requestUrl = this.packData.platform === 1 ? updataChannelConfig(androidConfigVo) : updataIosChannelConfig(androidConfigVo)
          requestUrl.then((data) => {
            if (data) {
              this.getData()
              this.active = 0
              this.packDialogVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.search {
  float: right;
  height: 40px;
  margin-right: -10px;
}
.appInfo {
  i.ivu-icon {
    display: inline-block;
    margin-top: 20px;
    font-size: 20px;
    vertical-align: top;
  }
  img {
    display: inline-block;
    width: 60px;
    height: 60px;
    margin: 0 5px;
    vertical-align: top;
    border: 1px solid #f2f2f2;
    border-radius: 5px;
  }
  .info {
    display: inline-block;
    padding-left: 5px;
    p {
      width: 80px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-bottom: 8px;
    }
    .copy {
      margin-bottom: 0;
      padding: 0px;
      color: #409eff;
    }
  }
}
.pagination {
  margin-top: 20px;
}
.editDialog {
  margin-top: -50px;
  padding: 0 10px;
  height: calc(100vh - 35px);
  overflow-y: scroll;
}
:deep(.el-dialog__body) {
  padding: 0 20px;
}
.rightSlide {
  float: right;
  width: calc(100% - 210px);
}
.leftSlide {
  float: left;
  width: 200px;
  .list {
    margin-top: 5px;
    height: calc(100vh - 220px);
    border: 1px solid #ebeff5;
    border-radius: 5px;
    overflow: auto;
  }
  li {
    display: block;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    overflow: hidden;
    img {
      float: left;
      width: 50px;
      height: 50px;
      margin-right: 10px;
      border-radius: 5px;
      border: 1px solid #f2f2f2;
    }
    p.title {
      padding-bottom: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
    }
    p.id {
      font-size: 12px;
    }
  }
  li.active,
  li:hover {
    background: #f2f2f2;
  }
}
.c-table-page {
  margin: 10px 0 !important;
  padding: 0 8px;
  text-align: right;
}
.el-button--text {
  padding: 0 0 5px 0;
}
.uploadState {
  span {
    display: inline-block;
    margin-right: 40px;
  }
  a {
    cursor: pointer;
    font-size: 16px;
  }
}
.el-drawer {
  .el-drawer__header {
    display: none;
  }
}
.dialog-footer {
  display: flex;
  .el-button {
    flex: 1;
    margin-left: 0;
    border-radius: 0;
  }
}
.el-icon-download {
  font-size: 22px;
}
:deep(.checkTable thead th:first-child .cell) {
  display: none !important;
}
.moreBtns {
  text-align: left;
}
</style>
